import React from "react"
import Container from "../atoms/Container"
import styled from "styled-components";
import { GatsbyImage } from "gatsby-plugin-image";
import PrismicRichText from "../atoms/PrismicRichText";
import { Link } from "gatsby";
import PortraitAnimation from "./PortraitAnimation.js";
import FullWidthAnimation from "./FullWidthAnimation.js";
import SquareAnimation from "./SquareAnimation.js";
import { useInView } from 'react-intersection-observer';
import FadeInSection from "../atoms/FadeIn.jsx";

const IntroContainer = styled.div`
    background-color: black;
    color: white;
    padding: 6rem 0;
    min-height: 100vh;

    a {
        text-decoration: none;
        font-weight: 500;
        height: max-content;
    }
`;


const ImageHolder = styled.div`
    padding: 2rem 1rem;
`;

const ThreePortrait = styled.div`
    display: grid;
    grid-template-columns: 1fr;
    grid-column-gap: 2rem;
    grid-template-rows: auto;

    @media( ${props => props.theme.breakpoints.md} ) {
        grid-template-columns: 1fr 1fr 1fr;
        padding: 2rem;

        .second-image {
            margin-top: 75%;
        }
        .third-image {
            text-align: right;
        }
  }
`;

const TwoPortrait = styled.div`
    display: grid;
    grid-template-columns: 1fr;
    grid-column-gap: 2rem;
    grid-template-rows: auto;

    @media( ${props => props.theme.breakpoints.md} ) {
        grid-template-columns: 1fr 1fr 1fr;
        padding: 2rem;

        .second-image {
            text-align: right;
            grid-column: 3;
        }
  }
`;

const FullWidth = styled.div`
    width: 100vw;
    padding: 2rem 0;

    @media( ${props => props.theme.breakpoints.md} ) {
        padding: 5rem 0;
  }
`;

const Square = styled.div`
    width: 80%;
    margin: 0 10%;

    @media( ${props => props.theme.breakpoints.md} ) {
        width: 50%;
        margin: 0 25%;
  }
`;



function Intro( props ) {

const image1 = props.homeImages.image_1;
const client1 = props.homeImages.client_1;
const link1 = props.homeImages.link_1.uid;
const image2 = props.homeImages.image_2;
const client2 = props.homeImages.client_2;
const link2 = props.homeImages.link_2.uid;
const image3 = props.homeImages.image_3;
const client3 = props.homeImages.client_3;
const link3 = props.homeImages.link_3.uid;
const image4 = props.homeImages.image_4;
const client4 = props.homeImages.client_4;
const link4 = props.homeImages.link_4.uid;
const image5 = props.homeImages.image_5;
const client5 = props.homeImages.client_5;
const link5 = props.homeImages.link_5.uid;
const image6 = props.homeImages.image_6;
const client6 = props.homeImages.client_6;
const link6 = props.homeImages.link_6.uid;
const image7 = props.homeImages.image_7;
const client7 = props.homeImages.client_7;
const link7 = props.homeImages.link_7.uid;

const colorGroup = ["1", "2", "3", "4", "5"]

// const { ref, inView, entry } = useInView({
//     /* Optional options */
//     root: null,
//     threshold: 0.5,
//   });


    return (
      <IntroContainer>
        <Container>
          <ThreePortrait>
            <Link to={`/case-study/${link1}`}>
              <FadeInSection>
                <ImageHolder>
                  <PortraitAnimation color={colorGroup[0]} image={image1} />
                  <PrismicRichText render={client1.richText} />
                </ImageHolder>
              </FadeInSection>
            </Link>
            <Link className="second-image" to={`/case-study/${link2}`}>
              <FadeInSection>
                <ImageHolder>
                  <PortraitAnimation color={colorGroup[1]} image={image2} />
                  <PrismicRichText render={client2.richText} />
                </ImageHolder>
              </FadeInSection>
            </Link>
            <Link className="third-image" to={`/case-study/${link3}`}>
              <FadeInSection>
                <ImageHolder>
                  <PortraitAnimation color={colorGroup[2]} image={image3} />
                  <PrismicRichText render={client3.richText} />
                </ImageHolder>
              </FadeInSection>
            </Link>
          </ThreePortrait>
        </Container>
        <FullWidth>
          <Link to={`/case-study/${link4}`}>
            <FadeInSection>
              <ImageHolder>
                <FullWidthAnimation image={image4} />
                <PrismicRichText render={client4.richText} />
              </ImageHolder>
            </FadeInSection>
          </Link>
        </FullWidth>
        <Container>
          <TwoPortrait>
            <Link to={`/case-study/${link6}`}>
              <FadeInSection>
                <ImageHolder>
                  <PortraitAnimation color={colorGroup[3]} image={image6} />
                  <PrismicRichText render={client6.richText} />
                </ImageHolder>
              </FadeInSection>
            </Link>
            <Link className="second-image" to={`/case-study/${link7}`}>
              <FadeInSection>
                <ImageHolder>
                  <PortraitAnimation color={colorGroup[4]} image={image7} />
                  <PrismicRichText render={client7.richText} />
                </ImageHolder>
              </FadeInSection>
            </Link>
          </TwoPortrait>
          <Square>
            <Link to={`/case-study/${link5}`}>
              <FadeInSection>
                <ImageHolder>
                  <SquareAnimation image={image5} />
                  <PrismicRichText render={client5.richText} />
                </ImageHolder>
              </FadeInSection>
            </Link>
          </Square>
        </Container>
      </IntroContainer>
    );
}


export default Intro;

